import { BrowserRouter } from 'react-router'

import { SessionProvider } from './auth/SessionProvider.js'
import { ErrorBoundary } from './components/ErrorBoundary.js'
import { AppRoutes } from './routes.js'

export function App() {
  return (
    <ErrorBoundary>
      <SessionProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </SessionProvider>
    </ErrorBoundary>
  )
}
